module.exports = __webpack_public_path__ + "assets/img/Location.83ee582b.png";